import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-signup-complete',
  templateUrl: './signup-complete.component.html',
  styleUrls: ['./signup-complete.component.scss']
})
export class SignupCompleteComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
